// extracted by mini-css-extract-plugin
module.exports = {"categories":"Categories_categories__2lcMj","accordion":"Categories_accordion__Sj_db","icon":"Categories_icon__21Gtr","category-title":"Categories_category-title__3K635"};